"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visitNode = void 0;
const exception_1 = require("../exception");
const visitNode = (visitor, node, arg) => {
    switch (node.type) {
        case "Definition":
            return visitor.visitDefinition(node, arg);
        case "Literal":
            return visitor.visitLiteral(node, arg);
        case "RecordLiteral":
            return visitor.visitRecordLiteral(node, arg);
        case "Symbol":
            return visitor.visitSymbol(node, arg);
        case "VectorLiteral":
            return visitor.visitVectorLiteral(node, arg);
    }
    throw new exception_1.LaskinError(`Unrecognized node type: ${node.type}`);
};
exports.visitNode = visitNode;
